export default function GetListeElementUniqueParPropriete(liste, prop) {
  const valeurs = [];
  let listeProps = null;
  if (liste && prop) {
    liste.forEach((face) => {
      if (face[prop] && !valeurs.includes(face[prop])) {
        valeurs.push(face[prop]);
      }
    });
    listeProps = valeurs.map((valeur) => {
      return { name: valeur, checked: false };
    });
  }
  function tri(a, b) {
    if (a.name < b.name) return -1;
    else if (a.name === b.name) return 0;
    return 1;
  }
  return listeProps.sort(tri);
}



// WEBPACK FOOTER //
// ./src/services/general/listeFilterDynamique.js